var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-autocomplete", {
    ref: "autocomplete",
    staticClass: "title-branding custom-autocomplete",
    attrs: {
      items: _vm.intermediary_search_results,
      filled: "",
      "search-input": _vm.search,
      label: "Search for intermediary",
      disabled: _vm.disabled || _vm.forceDisabled,
      "item-text": "label",
      "item-value": "int_id",
      "return-object": "",
      "truncate-length": "22",
      "error-messages": _vm.errorMessages
    },
    on: {
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      },
      change: _vm.stopSearch
    },
    scopedSlots: _vm._u([
      {
        key: "no-data",
        fn: function() {
          return [
            _c(
              "v-list-item",
              [
                _vm.loading
                  ? _c("v-list-item-title", [
                      _vm._v("\n                Searching...\n            ")
                    ])
                  : _c("v-list-item-title", [
                      _vm._v(
                        "\n                No data available\n            "
                      )
                    ])
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "append",
        fn: function() {
          return [
            _vm.intermediarySelected
              ? _c(
                  "v-btn",
                  {
                    attrs: { icon: "" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.clear($event)
                      },
                      mouseup: function($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                      }
                    }
                  },
                  [
                    _c("v-icon", { attrs: { dark: "" } }, [
                      _vm._v("\n                $mdiClose\n            ")
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.loading
              ? _c("v-progress-circular", {
                  attrs: {
                    width: 3,
                    size: 20,
                    color: _vm.$vuetify.theme.dark ? "white" : "primary",
                    indeterminate: ""
                  }
                })
              : _vm._e()
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.selected_intermediary,
      callback: function($$v) {
        _vm.selected_intermediary = $$v
      },
      expression: "selected_intermediary"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }